import { memo } from 'react';
import { arrowMarkerId } from '../style';
import type { ResolvedWireStyle } from '../style';

interface WireProps {
  className: string;
  x1: number;
  y1: number;
  x2: number;
  y2: number;
  resolved: ResolvedWireStyle;
}

function Wire({ className, x1, y1, x2, y2, resolved }: WireProps) {
  const markerEnd = resolved.markerEndColor ? `url(#${arrowMarkerId(resolved.markerEndColor)})` : undefined;
  const markerStart = resolved.markerStartColor ? `url(#${arrowMarkerId(resolved.markerStartColor)})` : undefined;
  return (
    <line
      className={className}
      x1={x1} y1={y1} x2={x2} y2={y2}
      style={{ stroke: resolved.color, strokeWidth: resolved.width, ...(resolved.dash ? { strokeDasharray: resolved.dash } : {}) }}
      markerEnd={markerEnd}
      markerStart={markerStart}
    />
  );
}

export default memo(Wire);
